import { VueConstructor } from 'vue'
import Router from 'vue-router'
import { Store } from 'vuex'
import idle from './idle'

export function installVue2Idle<TState>(Vue: VueConstructor, router: Router, store: Store<TState>) {
    Vue.use(idle, {
        router,
        store
    })
}
